<template>
  <div class="MainMenu__main-container">
    <div class="MainMenu__header">
      <div class="MainMenu__header-main">
        <div class="MainMenu__header-container">
          <div class="MainMenu__header-inner-container">
            <img
            class="MainMenu__logo"
            src="../../../static/images/logo.png">
            <div class="MainMenu__nav-container">
              <div class="MainMenu__nav">
                <router-link class="MainMenu__nav-item"
                  :to="{name: 'home-tab'}"
                  :class="{ 'active': $route.name === 'MainMenu' || $route.name === 'BroadcastingTab'}">
                  <i class="icon-ic_call"></i>
                </router-link>

                <router-link class="MainMenu__nav-item"
                  :to="{name: 'HistoryTab'}"
                  :class="{ 'active': $route.name === 'HistoryTab'}">
                  <i class="icon-ic_history"></i>
                </router-link>

                <router-link class="MainMenu__nav-item"
                  :to="{name: 'SettingsTab'}"
                  :class="{ 'active': $route.name === 'SettingsTab'}">
                  <i class="icon-ic_settings"></i>
                </router-link>
              </div>
              <div class="MainMenu__profile">
                <div class="MainMenu__profile-name">
                  {{user.name}}
                </div>
                <div class="MainMenu__profile-avatar-container"
                     @click="toggleMainMenu">
                  <img class="MainMenu__profile-avatar"
                       :src="userInfo.avatarUrl"
                       v-fallback-src="'../../../static/images/default-user-avatar.jpg'"/>
                  <i class="icon-ic_star MainMenu__profile-status-icon"
                     :class="{'pro': subscription.active}"></i>
                </div>
                <transition name="scale-vertically">
                  <div v-if="showMainMenu"
                       v-on-click-outside="hideMainMenu"
                       class="MainMenu__nav-menu">
                    <div class="MainMenu__nav-menu-action logout"
                         @click="logout()">
                      logout
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <router-view></router-view>

    <div class="MainMenu__footer"></div>
  </div>
</template>

<script>
  import router from '@/router';
  import HomeTab from './home-tab/home-tab';
  import HistoryTab from './history-tab/history-tab';
  import SettingsTab from './settings-tab/settings-tab';

  export default {
    components: {
      HomeTab,
      HistoryTab,
      SettingsTab
    },
    data() {
      return {
        showMainMenu: false,
        tabs: [
          {
            name: 'home-tab',
            icon: 'icon-ic_call'
          },
          {
            name: 'HistoryTab',
            icon: 'icon-ic_history'
          },
          {
            name: 'SettingsTab',
            icon: 'icon-ic_settings'
          }
        ],
        currentTab: 'home-tab'
      };
    },
    computed: {
      user() {
        return this.$store.getters.currentUser;
      },
      userInfo() {
        return this.$store.getters.currentUsersInfo;
      },
      subscription() {
        return this.$store.getters.subscription;
      }
    },
    methods: {
      selectTab(name) {
        router.push({name});
      },
      logout() {
        this.$store.dispatch('logout');
      },
      toggleMainMenu() {
        this.showMainMenu = !this.showMainMenu;
      },
      hideMainMenu() {
        this.showMainMenu = false;
      }
    },
    created() {
      this.$store.dispatch('connectCallChannelSocket');
      this.$store.dispatch('checkSubscription');
    }
  };
</script>

<style scoped lang="scss">
  @import 'style.scss';
</style>



// WEBPACK FOOTER //
// main-menu.vue?610c371a